var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ma-4"},[_c('products',{attrs:{"exclude-event-templates":"","exclude-requests":"","exclude-required":"","display-mode":"cashDesk","exclude-inactive":""},on:{"click:product":_vm.bookProduct}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }